/**
 * Resolve permission_pages.code for a URL path using the active catalog from
 * GET /permission-pages/active. Matches `category` (admin path) to pathname;
 * longest matching prefix wins.
 */

/** @param {string|undefined|null} p */
export function normalizePermissionPath(p) {
  if (p == null || typeof p !== "string") return "";
  const t = p.trim();
  if (!t) return "";
  return t.startsWith("/") ? t : `/${t}`;
}

/**
 * @param {string} pathname - e.g. location.pathname
 * @param {unknown[]} activePages - from Redux; items have `code`, `category`
 * @returns {string|null} permission_pages.code or null if no match / no catalog
 */
export function getPermissionCodeForPath(pathname, activePages) {
  if (!pathname || !Array.isArray(activePages) || activePages.length === 0) {
    return null;
  }
  const path = normalizePermissionPath(pathname);
  let bestCode = null;
  let bestLen = -1;

  for (const page of activePages) {
    const code = page?.code;
    if (!code || typeof code !== "string") continue;
    const raw = page?.category;
    if (raw == null || String(raw).trim() === "") continue;
    const segments = String(raw)
      .split(";")
      .map((s) => normalizePermissionPath(s.trim()))
      .filter(Boolean);
    for (const cat of segments) {
      if (path === cat || path.startsWith(`${cat}/`)) {
        if (cat.length > bestLen) {
          bestLen = cat.length;
          bestCode = code;
        }
      }
    }
  }
  return bestCode;
}
